<template>
  <div class="animated fadeIn">

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Files
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>Canonical URL</th>
                  <th>Updated At</th>
                </tr>
              </thead>
              <tbody>
                <loading-rows v-if="loading" cols="4"/>
                <tr v-for="file in files" v-if="!loading">
                  <td><router-link :to="{ name: 'File', params: {id: encodeCanonicalURL(file)} }">{{file.canonical_url}}</router-link></td>
                  <td>{{file.updated_at | moment('LLL')}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <pagination v-bind:totalEntries="pagination.total_entries" v-bind:totalPages="pagination.total_pages" v-bind:currentPage="pagination.current_page"></pagination>
      </div>
    </div>

  </div>
</template>

<script>

import files from 'services/files'
import Pagination from 'components/Pagination'
import LoadingRows from 'components/LoadingRows'

export default {
  name: 'files',
  created () {
    this.fetchData()
  },
  data () {
    return {
      files: [],
      pagination: {},
      order: 'updated_at desc',
      loading: false
    }
  },
  computed: {
    page () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return 1
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      files.all(this)
    },
    encodeCanonicalURL (file) {
      return btoa(file.canonical_url)
    }
  },
  components: {
    Pagination,
    LoadingRows
  }
}
</script>



// WEBPACK FOOTER //
// src/views/files/Files.vue